export { default } from './IconFont';



// WEBPACK FOOTER //
// ./src/components/icon-font/index.ts